import { HeaderContext } from "@tanstack/react-table";
import { useRef } from "react";

export default function SelectionHeader<RowType>(
  props: HeaderContext<RowType, any>
) {
  const {
    table: {
      getIsSomeRowsSelected,
      getIsAllRowsSelected,
      toggleAllRowsSelected,
    },
  } = props;

  const checkboxRef = useRef<HTMLInputElement>(null);

  if (!!checkboxRef.current) {
    checkboxRef.current.indeterminate =
      getIsSomeRowsSelected() && !getIsAllRowsSelected();
  }

  return (
    <div
      className="cursor-pointer select-none"
      onClick={() => toggleAllRowsSelected()}
    >
      <input
        type="checkbox"
        ref={checkboxRef}
        checked={getIsAllRowsSelected()}
        onChange={() => toggleAllRowsSelected()}
      />
    </div>
  );
}
